import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Map, GoogleApiWrapper, Marker } from 'google-maps-react'

const APIKEY = `${process.env.REACT_APP_COMUNIDADE_IUPP_GOOGLE_MAPS_KEY}`

function MapContainer (props) {
  useEffect(() => {
  }, [props.geolocation, props.stores, props.offers])

  const displayMarkers = stores => {
    return stores.data.map((store, index) => {
      return <Marker title={store.name} key={index} id={index} name={store.name} position={{ lat: store.place.location.latitude, lng: store.place.location.longitude }} />
    })
  }

  return (
    <Map
      google={props.google}
      zoom={11}
      style={props.styles}
      initialCenter={props.geolocation}
      center={props.geolocation}
    >
      { props.stores ? displayMarkers(props.stores) : ''}
    </Map>
  )
}

export default GoogleApiWrapper({
  apiKey: APIKEY
})(MapContainer)

MapContainer.propTypes = {
  google: PropTypes.string,
  styles: PropTypes.string,
  geolocation: PropTypes.string,
  stores: PropTypes.array,
  offers: PropTypes.array
}



// WEBPACK FOOTER //
// ./src/features/MeuBairro/GoogleMaps/index.js